import { createContext } from 'react';

export const AuthInstanceContext = createContext('');
